import { FC } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import { ArrowDropUp } from '@mui/icons-material';
import { formatTimestamp } from '@utils/common';

interface DealUpdatedDetailsProps {
  logs: any[];
  openHistoryHandler: () => void;
}

const DealUpdatedDetails: FC<DealUpdatedDetailsProps> = (props: DealUpdatedDetailsProps) => {
  const { logs, openHistoryHandler } = props;
  const email = logs?.[0]?.createdByEmail;
  const updatedAt = formatTimestamp(logs?.[0]?.createdAt);
  if (!logs || logs.length === 0) return <></>;
  return (
    <Box>
      <Typography fontSize={'0.75rem'} lineHeight={'1rem'} color={'#B4B4B4'} fontWeight={700}>
        Last Updated
      </Typography>
      <Stack direction={'row'} gap={'0.5rem'} alignItems={'center'}>
        <Typography fontSize={'0.875rem'} lineHeight={'1.25rem'} color={'#6C6C6C'} fontWeight={700}>
          {email} | {updatedAt}
        </Typography>
        <IconButton
          onClick={openHistoryHandler}
          disableFocusRipple
          disableRipple
          disableTouchRipple
        >
          <ArrowDropUp
            sx={{
              color: '#2F736E',
            }}
          />
        </IconButton>
      </Stack>
    </Box>
  );
};

export default DealUpdatedDetails;
